import { moduleFactory } from "@/factories/module";
import { findMatchingEnumByValue, findMatchingEnumStringValue } from "@/modules/enum/findMatch";
import { _enumValues } from "@/modules/enum/values";

export const enumModule = moduleFactory.create({
  values: _enumValues,
  findMatchingValue: findMatchingEnumByValue,
  findMatchingStringValue: findMatchingEnumStringValue,
});
